// DE drafted — queued for native review. ITSM commons admin (R-131): the
// cloud-owned masters every site consumes through the down-sync replicas.
export const itsmCommons = {
  // Every write on this page reports its outcome. The create/update endpoints are
  // single upserts, so the call site — which knows whether the row had an id —
  // picks "created" or "updated".
  toastRoutingRuleCreated: { de: 'Routingregel angelegt.', en: 'Routing rule created.' },
  toastRoutingRuleUpdated: { de: 'Routingregel {ord} aktualisiert.', en: 'Routing rule {ord} updated.' },
  toastRoutingRuleDeleted: { de: 'Routingregel {ord} gelöscht.', en: 'Routing rule {ord} deleted.' },
  toastGroupUpdated: { de: 'Gruppe „{name}“ aktualisiert.', en: 'Group “{name}” updated.' },
  toastOnCallCreated: { de: 'Bereitschaftsschicht angelegt.', en: 'On-call shift created.' },
  toastOnCallDeleted: { de: 'Bereitschaftsschicht gelöscht.', en: 'On-call shift deleted.' },
  toastTemplateCreated: { de: 'Change-Vorlage „{name}“ angelegt.', en: 'Change template “{name}” created.' },
  toastKbCreated: { de: 'Artikel „{name}“ angelegt.', en: 'Article “{name}” created.' },
  toastKbConfirmed: { de: 'Artikel „{name}“ bestätigt.', en: 'Article “{name}” confirmed.' },
  toastSlaSaved: { de: 'SLA-Richtlinien gespeichert.', en: 'SLA policies saved.' },
  toastMatrixSaved: { de: 'Prioritätsmatrix gespeichert.', en: 'Priority matrix saved.' },
  toastClassCreated: { de: 'Klasse {code} angelegt.', en: 'Class {code} created.' },
  toastModelCreated: { de: 'Modell {name} angelegt.', en: 'Model {name} created.' },
  toastModelUpdated: { de: 'Modell {name} aktualisiert.', en: 'Model {name} updated.' },
  toastModelApproved: { de: 'Modell {name} freigegeben.', en: 'Model {name} approved.' },
  toastModelMerged: {
    de: '{loser} in {winner} zusammengeführt.',
    en: '{loser} merged into {winner}.',
  },
  // Only the REAL apply is a write; the dry-run preview changes nothing.
  toastImportApplied: {
    de: 'Import angewendet — {applied} von {total} Zeilen.',
    en: 'Import applied — {applied} of {total} rows.',
  },
  // A batch save (matrix cells, SLA rows) where only SOME writes landed: say how
  // many, never report the whole batch as one success or one failure.
  toastPartialSave: {
    de: '{failed} von {total} Änderungen konnten nicht gespeichert werden — sie bleiben im Bearbeitungsmodus.',
    en: "{failed} of {total} changes couldn't be saved — they stay in edit mode.",
  },

  // Every tab that gates inline editing behind Edit / Save / Cancel asks before
  // throwing edits away — one pair of strings, not one per tab.
  discardEditsTitle: { de: 'Änderungen verwerfen?', en: 'Discard changes?' },
  discardEditsMsg: {
    de: 'Ihre nicht gespeicherten Änderungen gehen verloren.',
    en: 'Your unsaved changes will be lost.',
  },
  slaHint: {
    de: 'Reaktions- und Lösungsziele je Priorität.',
    en: 'Response and resolution targets per priority.',
  },
  pageTitle: { de: 'ITSM-Stammdaten', en: 'ITSM Commons' },
  pageDesc: {
    de: 'Cloud-eigene Stammdaten (Prioritätsmatrix, SLA, Vorlagen, KB) — synchronisiert zu allen Standorten.',
    en: 'Cloud-owned masters (priority matrix, SLA, templates, KB) — synced down to every site.',
  },

  tabMatrix: { de: 'Prioritätsmatrix', en: 'Priority matrix' },
  tabSla: { de: 'SLA', en: 'SLA' },
  tabRouting: { de: 'Routing', en: 'Routing' },
  tabGroups: { de: 'Gruppen', en: 'Groups' },
  tabOnCall: { de: 'Rufbereitschaft', en: 'On-call' },
  tabTemplates: { de: 'Change-Vorlagen', en: 'Change templates' },
  tabKb: { de: 'Knowledge Base', en: 'Knowledge base' },
  tabBenchmarks: { de: 'KPI-Benchmarks', en: 'KPI benchmarks' },
  tabTaxonomy: { de: 'Taxonomie', en: 'Taxonomy' },
  tabModels: { de: 'Modelle', en: 'Models' },
  tabTokens: { de: 'Standort-Tokens', en: 'Location tokens' },
  colActions: { de: 'Aktionen', en: 'Actions' },

  matrixHint: {
    de: 'Impact × Dringlichkeit → Priorität. „Bearbeiten“ drücken, P1..P4 je Zelle wählen, dann speichern. Wirkt in ≤5 min an allen Standorten.',
    en: 'Impact × urgency → priority. Press Edit, pick P1..P4 per cell, then save. Reaches every site within ≤5 min.',
  },
  impact: { de: 'Impact', en: 'Impact' },
  urgency: { de: 'Dringlichkeit', en: 'Urgency' },

  slaResponse: { de: 'Reaktion (min)', en: 'Response (min)' },
  slaResolution: { de: 'Lösung (min)', en: 'Resolution (min)' },
  slaEnabled: { de: 'Aktiv', en: 'Enabled' },
  yes: { de: 'ja', en: 'yes' },
  no: { de: 'nein', en: 'no' },
  save: { de: 'Speichern', en: 'Save' },
  saved: { de: 'Gespeichert', en: 'Saved' },

  rtHint: {
    de: 'Zuweisungsregeln (E.4) — erste Übereinstimmung gewinnt, sortiert nach Reihenfolge.',
    en: 'Assignment rules (E.4) — first match wins, ordered by rank.',
  },
  rtOrd: { de: 'Reihenfolge', en: 'Order' },
  rtCategory: { de: 'Kategorie', en: 'Category' },
  rtClassPrefix: { de: 'Klassen-Präfix', en: 'Class prefix' },
  rtLocationPrefix: { de: 'Standort-Präfix', en: 'Location prefix' },
  rtGroup: { de: 'Gruppe', en: 'Group' },
  rtActive: { de: 'Aktiv', en: 'Active' },
  phRtCategory: { de: 'z. B. climate.breach', en: 'e.g. climate.breach' },
  phRtClassPrefix: { de: 'z. B. D30', en: 'e.g. D30' },
  phRtLocationPrefix: { de: 'z. B. GR07', en: 'e.g. GR07' },
  rtNew: { de: 'Neue Regel', en: 'New rule' },
  rtEdit: { de: 'Regel bearbeiten', en: 'Edit rule' },
  rtDeleteTitle: { de: 'Regel {ord} löschen?', en: 'Delete rule {ord}?' },
  rtDeleteMsg: {
    de: 'Die Regel wird an allen Standorten entfernt.',
    en: 'The rule is removed from every site.',
  },

  grpKey: { de: 'Schlüssel', en: 'Key' },
  grpName: { de: 'Name', en: 'Name' },
  grpType: { de: 'Typ', en: 'Type' },
  grpSchedule: { de: 'Kalender', en: 'Schedule' },
  grpManager: { de: 'Manager-Benutzer-ID', en: 'Manager user ID' },
  phUserId: {
    de: 'z. B. a2f1e9c4-3b7d-4e21-9f6a-1c8d5e0b7a42',
    en: 'e.g. a2f1e9c4-3b7d-4e21-9f6a-1c8d5e0b7a42',
  },
  grpScheduleNone: { de: '— kein Kalender —', en: '— no schedule —' },
  grpEdit: { de: 'Gruppe bearbeiten', en: 'Edit group' },
  invalidUuid: { de: 'Keine gültige UUID', en: 'Not a valid UUID' },

  ocHint: {
    de: 'Rufbereitschafts-Rota (D.3) — cloud-gepflegt, repliziert zu allen Standorten.',
    en: 'On-call rota (D.3) — cloud-authored, replicated to every site.',
  },
  ocGroup: { de: 'Gruppe', en: 'Group' },
  ocUser: { de: 'Benutzer-ID', en: 'User ID' },
  ocStarts: { de: 'Beginn', en: 'Starts' },
  ocEnds: { de: 'Ende', en: 'Ends' },
  ocNew: { de: 'Neue Schicht', en: 'New shift' },
  ocCreate: { de: 'Schicht anlegen', en: 'Create shift' },
  ocDeleteTitle: { de: 'Schicht löschen?', en: 'Delete shift?' },
  ocDeleteMsg: {
    de: 'Die Rufbereitschafts-Schicht wird an allen Standorten entfernt.',
    en: 'The on-call shift is removed from every site.',
  },
  ocInvalidRange: { de: 'Ende muss nach dem Beginn liegen', en: 'End must be after start' },

  tplName: { de: 'Name', en: 'Name' },
  tplType: { de: 'Typ', en: 'Type' },
  tplRisk: { de: 'Risiko', en: 'Risk' },
  tplClass: { de: 'Klasse (optional)', en: 'Class (optional)' },
  tplImpl: { de: 'Umsetzungsplan', en: 'Implementation plan' },
  tplBackout: { de: 'Backout-Plan', en: 'Backout plan' },
  phTplName: { de: 'z. B. Anwendungsdienst neu starten', en: 'e.g. Restart application service' },
  phClassCode: { de: 'z. B. D30', en: 'e.g. D30' },
  phTplImpl: {
    de: 'z. B. Schritt-für-Schritt-Plan für die Umsetzung …',
    en: 'e.g. Step-by-step plan for the rollout …',
  },
  phTplBackout: {
    de: 'z. B. So wird die Änderung im Fehlerfall rückgängig gemacht …',
    en: 'e.g. How to revert this change if it fails …',
  },
  tplCab: { de: 'CAB erforderlich', en: 'Requires CAB' },
  tplActive: { de: 'Aktiv', en: 'Active' },
  tplNew: { de: 'Neue Vorlage', en: 'New template' },
  tplCreate: { de: 'Vorlage anlegen', en: 'Create template' },

  kbTitle: { de: 'Titel', en: 'Title' },
  kbBody: { de: 'Inhalt (Prozedur)', en: 'Body (procedure)' },
  kbSafety: { de: 'Sicherheitshinweise', en: 'Safety notes' },
  kbCategory: { de: 'Kategorie', en: 'Category' },
  kbSkill: { de: 'Skill', en: 'Skill' },
  phKbTitle: { de: 'z. B. Festsitzenden FCU zurücksetzen', en: 'e.g. How to reset a stuck FCU' },
  phKbBody: { de: 'z. B. Schritt-für-Schritt-Lösung …', en: 'e.g. Step-by-step resolution …' },
  phKbSafety: {
    de: 'z. B. Strom abschalten, bevor das Panel geöffnet wird',
    en: 'e.g. Lock out power before opening the panel',
  },
  phKbCategory: { de: 'z. B. HLK', en: 'e.g. HVAC' },
  phKbSkill: { de: 'z. B. HVAC-L2', en: 'e.g. HVAC-L2' },
  kbConfirmed: { de: 'Gelesen bestätigt', en: 'Read-confirmed' },
  kbConfirm: { de: 'Als gelesen bestätigen', en: 'Confirm read' },
  kbNew: { de: 'Neuer Artikel', en: 'New article' },
  kbCreate: { de: 'Artikel anlegen', en: 'Create article' },

  bmClass: { de: 'Klasse', en: 'Class' },
  bmUptime: { de: 'Ø Verfügbarkeit', en: 'Avg uptime' },
  bmMtbf: { de: 'Ø MTBF (h)', en: 'Avg MTBF (h)' },
  bmMttr: { de: 'Ø MTTR (h)', en: 'Avg MTTR (h)' },
  bmIncidents: { de: 'Ø Incidents/Q', en: 'Avg incidents/qtr' },
  bmSample: { de: 'Assets', en: 'Assets' },
  bmComputed: { de: 'Berechnet', en: 'Computed' },
  bmHint: {
    de: 'Nächtlicher Roll-up aus den Standort-Spiegeln — nur Lesen.',
    en: 'Nightly roll-up from the site mirrors — read-only.',
  },

  empty: { de: 'Keine Einträge', en: 'No entries' },
  loadError: { de: 'Laden fehlgeschlagen', en: 'Failed to load' },
  cancel: { de: 'Abbrechen', en: 'Cancel' },

  taxSearch: { de: 'Code oder Name suchen…', en: 'Search code or name…' },
  taxLevelAll: { de: 'Alle Ebenen', en: 'All levels' },
  taxCode: { de: 'Code', en: 'Code' },
  taxName: { de: 'Name', en: 'Name' },
  taxLevel: { de: 'Ebene', en: 'Level' },
  taxParent: { de: 'Übergeordnet', en: 'Parent' },
  taxStandardRef: { de: 'Standardreferenz', en: 'Standard ref' },
  taxDetailTitle: { de: 'Klassendetails', en: 'Class details' },
  taxActive: { de: 'Aktiv', en: 'Active' },
  taxInactive: { de: 'Inaktiv', en: 'Inactive' },
  taxUpdated: { de: 'Zuletzt geändert', en: 'Last updated' },
  taxKey: { de: 'Schlüssel', en: 'Key' },
  taxHandling: { de: 'Handhabung', en: 'Handling' },
  taxTracking: { de: 'Erfassung', en: 'Tracking' },
  taxTagPrefix: { de: 'Tag-Präfix', en: 'Tag prefix' },
  taxAssetKind: { de: 'Asset-Art', en: 'Asset kind' },
  taxConnected: { de: 'Vernetztes Gerät', en: 'Connected device' },
  taxSanitisation: { de: 'Zertifizierte Löschung', en: 'Certified wipe' },
  taxDomains: { de: 'Bereiche', en: 'Domains' },
  // No domains of its own = inherited from the nearest ancestor that states any.
  taxDomainsInherited: { de: 'Vom Elternknoten geerbt', en: 'Inherited from parent' },
  taxExpectsEndUser: { de: 'Erwartet Endnutzer', en: 'Expects end user' },
  taxExpectsManagedBy: { de: 'Erwartet Verantwortliche', en: 'Expects managed by' },
  taxIfrs: { de: 'IFRS-Kategorie', en: 'IFRS category' },
  taxOverview: { de: 'Übersicht', en: 'Overview' },
  taxIdentity: { de: 'Identität', en: 'Identity' },
  taxDefaults: { de: 'Vorgaben', en: 'Defaults' },
  taxCrit: { de: 'Kritikalität', en: 'Criticality' },
  taxLife: { de: 'Nutzungsdauer (J)', en: 'Useful life (y)' },
  taxNewClass: { de: 'Neue Klasse', en: 'New class' },
  taxNameDe: { de: 'Name (DE)', en: 'Name (DE)' },
  taxMinStock: { de: 'Mindestbestand (Ersatzteile)', en: 'Min. spare stock' },
  phTaxCode: { de: 'z. B. D30.cool.fcu', en: 'e.g. D30.cool.fcu' },
  phTaxParent: { de: 'z. B. D30', en: 'e.g. D30' },
  phTaxName: { de: 'z. B. Gebläsekonvektor', en: 'e.g. Fan coil unit' },
  phTaxNameDe: { de: 'z. B. Gebläsekonvektor', en: 'e.g. Gebläsekonvektor' },
  phLife: { de: 'z. B. 10', en: 'e.g. 10' },
  phMinStock: { de: 'z. B. 2', en: 'e.g. 2' },
  taxCount: { de: '{shown} von {total} Einträgen', en: '{shown} of {total} entries' },
  // R-165 / D-120 — asset model master (the product catalogue).
  mdlManufacturer: { de: 'Hersteller', en: 'Manufacturer' },
  mdlNumber: { de: 'Modellnummer', en: 'Model number' },
  mdlName: { de: 'Bezeichnung', en: 'Name' },
  phMdlManufacturer: { de: 'z. B. Daikin', en: 'e.g. Daikin' },
  phMdlNumber: { de: 'z. B. FTXM35', en: 'e.g. FTXM35' },
  phMdlName: { de: 'Standard: Hersteller + Modellnummer', en: 'Defaults to manufacturer + model number' },
  phMdlUnitCost: { de: 'z. B. 450.00', en: 'e.g. 450.00' },
  mdlClass: { de: 'Klasse (Sub-Typ)', en: 'Class (sub-type)' },
  mdlPickClass: { de: '— Sub-Typ wählen —', en: '— pick a sub-type —' },
  mdlLife: { de: 'Nutzungsdauer (J)', en: 'Useful life (y)' },
  mdlCrit: { de: 'Kritikalität (Vorgabe)', en: 'Default criticality' },
  mdlStrategy: { de: 'Wartungsstrategie (Vorgabe)', en: 'Default maintenance strategy' },
  mdlMinStock: { de: 'Mindestbestand', en: 'Min. stock' },
  // ─── R-239: the commerce half of a product ────────────────────────────────
  mdlUnitCost: { de: 'Stückkosten', en: 'Unit cost' },
  mdlUnitCostHint: {
    de: 'AED. Wird später von Bestellpositionen verwendet.',
    en: 'AED. Used by request line items later.',
  },
  mdlUom: { de: 'Maßeinheit', en: 'Unit of measure' },
  mdlUomPh: { de: 'z. B. Stück', en: 'e.g. each' },
  mdlUomHint: {
    de: 'Die Einheit, auf die sich der Preis bezieht — Stück, Meter, Rolle. Leer ⇒ Stück.',
    en: 'The unit the price is per — each, metre, roll. Blank ⇒ each.',
  },
  mdlDomains: { de: 'Domänen', en: 'Domains' },
  mdlDomainsHint: {
    de: 'Darf die Domänen der Klasse nur EINSCHRÄNKEN, nie erweitern. Keine gewählt ⇒ die der Klasse.',
    en: 'May only NARROW the class’s domains, never widen them. None selected ⇒ the class’s own.',
  },
  mdlOrderable: { de: 'Bestellbar', en: 'Orderable' },
  mdlOrderableLabel: {
    de: 'Erscheint in Anträgen und im Wareneingang',
    en: 'Appears in requests and intake',
  },
  mdlOrderableHint: {
    de: 'Ausschalten für ein ausgelaufenes Produkt, von dem noch Einheiten im Bestand sind — bestehende Anlagen bleiben unberührt.',
    en: 'Turn off for a retired SKU you still own units of — its existing assets are untouched.',
  },
  mdlInherit: { de: '— von Klasse erben —', en: '— inherit from class —' },
  // R-166 — the product's own attribute values, authored against the class
  // dictionary so the site register can autofill them.
  mdlSpecsSection: { de: 'Produktmerkmale', en: 'Product specifications' },
  mdlSpecsHint: {
    de: 'Hier gesetzte Werte füllt das Anlagenregister automatisch aus — sie müssen nicht je Gerät erfasst werden.',
    en: 'Values set here are autofilled by the asset register — they need not be typed per unit.',
  },
  mdlSpecsNoDefs: {
    de: 'Für Klasse {class} sind keine Merkmale definiert. Merkmale werden im Reiter „Taxonomie“ gepflegt.',
    en: 'Class {class} has no attributes defined. Attributes are maintained on the Taxonomy tab.',
  },
  mdlSpecsUnmapped: {
    de: 'Nicht zugeordnet und daher ohne Autofill: {keys}. Für ein Autofill muss die Klasse ein passendes Merkmal definieren.',
    en: 'Not mapped, so these never autofill: {keys}. Define a matching class attribute to make them autofill.',
  },
  // R-240 — since D-146 nothing else asks for these, so the model form says so.
  // Stated, not enforced: the save still goes through.
  mdlSpecsMissingMandatory: {
    de: 'Die Klasse verlangt: {keys}. Ohne Angabe registrieren Einheiten dieses Modells ohne diese Werte.',
    en: 'The class requires: {keys}. Left blank, units of this model register with those values unset.',
  },
  mdlSearch: { de: 'Hersteller, Nummer, Klasse …', en: 'Manufacturer, number, class …' },
  mdlNew: { de: 'Neues Modell', en: 'New model' },
  mdlEdit: { de: 'Bearbeiten', en: 'Edit' },
  mdlEditTitle: { de: 'Modell bearbeiten', en: 'Edit model' },
  mdlCount: { de: '{shown} von {total} Modellen', en: '{shown} of {total} models' },
  mdlReview: { de: 'Prüfstatus', en: 'Review' },
  mdlReviewAll: { de: 'Alle', en: 'All' },
  mdlApproved: { de: 'geprüft', en: 'approved' },
  mdlUnapproved: { de: 'ungeprüft', en: 'unapproved' },
  mdlApprove: { de: 'Freigeben', en: 'Approve' },
  mdlOrigin: { de: 'Herkunft', en: 'Origin' },
  mdlFromSite: { de: 'Standort', en: 'Site' },
  mdlFromCloud: { de: 'Cloud', en: 'Cloud' },
  mdlQueue: { de: '{n} zu prüfen', en: '{n} to review' },
  mdlQueueHint: {
    de: 'Ungeprüfte Modelle sind an allen Standorten voll nutzbar — die Prüfung ist Datenpflege, keine Freigabe-Sperre.',
    en: 'Unapproved models are fully usable at every site — review is data hygiene, not a gate.',
  },
  mdlMerge: { de: 'Zusammenführen', en: 'Merge' },
  mdlMergeTitle: { de: 'Modelle zusammenführen', en: 'Merge models' },
  mdlMergeWinner: { de: 'Bleibt bestehen', en: 'Row that survives' },
  mdlPickWinner: { de: '— Zielmodell wählen —', en: '— pick the surviving model —' },
  mdlMergeIntro: {
    de: '{loser} wird ersetzt und bleibt als Verweis erhalten (nicht gelöscht) — Assets darauf werden automatisch umgehängt.',
    en: '{loser} is superseded and kept as an alias (never deleted) — assets pointing at it are repointed automatically.',
  },
  mdlMergeConfirmTitle: { de: 'Zusammenführen bestätigen', en: 'Confirm merge' },
  mdlMergeConfirmBody: {
    de: '{loser} wird ersetzt. Das lässt sich nur durch erneutes Anlegen rückgängig machen.',
    en: '{loser} will be superseded. Undoing this means creating the row again.',
  },
  taxAttrs: { de: 'Attribut-Definitionen', en: 'Attribute definitions' },
  taxPm: { de: 'PM-Katalog', en: 'PM catalog' },
  taxInherit: {
    de: 'Attribute werden auf Klassen-Ebene definiert — Sub-Typen erben sie.',
    en: 'Attributes are defined at class level — sub-types inherit them.',
  },
  taxMandatory: { de: 'Pflicht', en: 'Mandatory' },
  taxUnit: { de: 'Einheit', en: 'Unit' },
  taxType: { de: 'Typ', en: 'Type' },
  taxActivity: { de: 'Tätigkeit', en: 'Activity' },
  taxFreq: { de: 'Frequenz', en: 'Frequency' },
  taxFreqEvent: { de: 'ereignisbasiert', en: 'event-based' },
  taxDuration: { de: 'Dauer (min)', en: 'Duration (min)' },
  taxSkill: { de: 'Skill', en: 'Skill' },

  tokToken: { de: 'Token', en: 'Token' },
  tokPattern: { de: 'Muster', en: 'Pattern' },
  tokDesc: { de: 'Beschreibung', en: 'Description' },

  importBtn: { de: 'CSV-Import', en: 'CSV import' },
  importEntity: { de: 'Zieltabelle', en: 'Target catalog' },
  importCsv: { de: 'CSV-Inhalt (Datei wählen oder einfügen)', en: 'CSV content (pick a file or paste)' },
  phImportCsv: {
    de: 'z. B. code,parent_code,level,name_en,name_de,…',
    en: 'e.g. code,parent_code,level,name_en,name_de,…',
  },
  importDryRun: { de: 'Prüfen (Dry-Run)', en: 'Validate (dry-run)' },
  importApply: { de: 'Import anwenden', en: 'Apply import' },
  importReportOk: {
    de: '{applied} von {total} Zeilen gültig',
    en: '{applied} of {total} rows valid',
  },
  importReportApplied: {
    de: '{applied} von {total} Zeilen importiert',
    en: '{applied} of {total} rows imported',
  },
  importErrors: { de: 'Fehler', en: 'Errors' },
  importLine: { de: 'Zeile', en: 'Line' },
  importHint: {
    de: 'Erst prüfen, dann anwenden. Änderungen erreichen alle Standorte in ≤5 min.',
    en: 'Validate first, then apply. Changes reach every site within ≤5 min.',
  },
} as const;
